import useVehicle from '@/hooks/useVehicle'
import { useVehicleChargeSchedule } from '@/hooks/useVehicleChargeSchedule'
import {
  daysOfWeekToScheduleDescription,
  scheduleToGoalsDescriptions,
} from '../utils/chargeScheduleUtils'
import { generateLimitsText } from '@/types/chargeSchedule/chargeSchedule.utils'
import { unenrollmentVehicleDisplayName } from '../../../utils'
import { SuggestionCardProps } from '../DeviceSuggestionCard'
import { useDataAndSetLoadedState } from '../../hooks/useDataAndSetLoadedState'

export type Props = SuggestionCardProps & {
  vehicleId: number
  settingsWhitelist: string[]
}
export function useLoadData(props: Props) {
  const { vehicleId } = props
  const vehicle = useVehicle(vehicleId)
  const chargeSchedule = useVehicleChargeSchedule(vehicleId)
  const isLoading = !vehicle || !chargeSchedule
  return {
    isLoadingOrIdle: isLoading,
    data: {
      vehicle,
      chargeSchedule,
    },
  }
}

export default function useViewModel(props: Props) {
  const { vehicleId, setLoadedSignal, articles, settingsWhitelist } = props
  const {
    data: { vehicle, chargeSchedule },
    isLoadingOrIdle,
  } = useDataAndSetLoadedState({
    useLoader: useLoadData,
    props,
    setLoadedSignal: setLoadedSignal,
  })

  const dayOfWeekScheduleDescription = daysOfWeekToScheduleDescription(
    chargeSchedule?.charge_schedule_days_of_week ?? [],
  )

  const limitsText = generateLimitsText(chargeSchedule)
  const goalsDescriptions = scheduleToGoalsDescriptions(chargeSchedule)

  const displayName = vehicle ? unenrollmentVehicleDisplayName(vehicle) : ''

  const settingPaths = {
    chargeSchedule: `/devices/vehicle/${vehicleId}/scheduling`,
    limits: `/devices/vehicle/${vehicleId}/limits`,
    goals: `/devices/vehicle/${vehicleId}/goals`,
  }

  return {
    vehicle,
    chargeSchedule,
    isLoadingOrIdle,
    dayOfWeekScheduleDescription,
    limitsText,
    goalsDescriptions,
    displayName,
    settingPaths,
    articles,
    settingsWhitelist,
  }
}
